import {createMuiTheme} from '@material-ui/core/styles';

const getColor = () => {
  switch (Config.base.uiColor) {
    case 'green':
      return '#8bc34a';
    case 'yellow':
      return '#ffeb3b';
    default:
      return '#F01345';
  }
};

export default createMuiTheme({
  palette: {
    primary: {
      main: getColor(),
    },
  },
});
